import type { ActivityLines, ChoiceField, WireChoice } from "./protocol";

/** The choice's card rows: G1's own `fields`, else the deprecated `display.fields`. */
export function choiceFields(choice: WireChoice): ChoiceField[] {
  return choice.fields?.length ? choice.fields : (choice.display?.fields ?? []);
}

/** The choice's call lines: G1's own `activity`, else the deprecated `display.activity`. */
export function choiceActivity(choice: WireChoice): ActivityLines | string | null {
  if (choice.activity && Object.keys(choice.activity).length) return choice.activity;
  return choice.display?.activity ?? null;
}
